/**
 * Get the ID of a destination
 * @param {*} destination destination object
 * @returns {string} destination ID
 */
export function getDestinationId(destination) {
    return destination._id;
}

/**
 * Get the type of a destination
 * @param {*} destination destination object
 * @returns {string} destination type 
 */
export function getDestinationType(destination) {
    if (destination.city) {
        return "CITY";
    }
    return "COUNTRY";
}